/* eslint-disable import/prefer-default-export */
import properties from '../../../modules/ajio-util/properties';

const imageBasePath = `${properties.getProperty('imageBaseUrl')}/static/img/`;
const parentUrl = `${properties.getProperty('parentUrl')}`;

// content
export const SELECT_SALE_DAY = 'Select a sale day';
export const HEADER_OFFSET = 80;
export const WEB_HEADER_OFFSET = 170;
export const EVENT_START_PREFIX = 'Event Starts in';
export const EVENT_END_PREFIX = 'Event Ends in';
export const EVENT_PRESALE_BOTTOM_CONTENT1 = 'Amazing Rewards';
export const EVENT_PRESALE_BOTTOM_CONTENT2 =
  'In every 3 hours, Top shoppers will get amazing rewards. Keep your wishlist ready.';
export const EVENT_PRESALE_CTA_TEXT = 'View Events &amp; Rewards';
export const EVENT_ACTIVESALE_BOTTOM_CONTENT1 = 'Top shopper gets';
export const EVENT_POSTSALE_TOP_CONTENT1 = 'Event is over';
export const EVENT_POSTSALE_TOP_CONTENT2 = 'Thank you for your participation';
export const EVENT_POSTSALE_BOTTOM_CONTENT1 =
  "We'll announce the grand prize winner soon. There is a possibility for you to climb up the leaderboard even after the event is over.";
export const EVENT_ACTIVESALE_CTA_TEXT = 'Shop More';
export const UPCOMING_EVENT_START_TEXT = 'Event Starts in ';

// urls
export const GRAND_PRIZE_URL = '/top-shopper/grand-prize';
export const EVENT_WINNER_URL = '/top-shopper/events-and-winners';
export const SHOP_MORE_URL = `${parentUrl}/s/iconic-fashion-sale-4335-60831`;
export const TERMS_CONDITION_URL = `${parentUrl}/help/termsAndCondition`;
export const HOME_PAGE_URL = `${parentUrl}/`;

// images
export const COLOUR_FLAG_HANGING_BANNER = `${imageBasePath}tsprs-flag-hanging-banner.png`;
export const DESK_COLOUR_FLAG_HANGING_BANNER = `${imageBasePath}tsprs-desk-flag-hanging-banner.png`;
export const TEST_SALE_ICON = `${imageBasePath}tsprs-sale-icon.png`;
export const GRAND_PRICE_BANNER = `${imageBasePath}tsprs-grand-prize-banner.png`;
export const GIFT_BOX_ICON = `${imageBasePath}tsprs-gift-box.svg`;
export const FESTIVE_GIFT_BOX_ICON = `${imageBasePath}tsprs-festive-blast.svg`;
export const BALOON_IMAGE = `${imageBasePath}tsprs-balloons.svg`;

export const eventsWinnersPage = { // Not used
  activeDays: ['2021-05-20', '2021-05-21', '2021-05-23'],
  activeSlot: {
    offer: {
      bannerImageURL: `${properties.getProperty(
        'imageBaseUrl'
      )}/medias/sys_master/root/20210403/K3KJ/6068a0757cdb8c1f147924ed/eyebogler_green_polo_t-shirt_with_welt_pocket.jpg`,
      description: 'Armani Duffle Bag',
      label: 'Worth ₹15,000'
    },
    slot: {
      date: '2021-05-17',
      endTime: 0,
      startTime: 0,
      timeInterval: '15-18'
    },
    userList: [
      {
        rank: 0,
        name: 'Vishal Kaith',
        mobile: '980xxxxx65',
        uuid: '64dfbbf9-4374-4fe7-8cd1-4fda41d25762'
      }
    ]
  },
  bannerImageURL: 'https://assets.ajio.com/static/img/Ajio-Logo.svg',
  currentScheduleStop: 0,
  description: 'string',
  nextScheduleStart: 0,
  pastSlots: [
    {
      offer: {
        bannerImageURL: `${properties.getProperty(
          'imageBaseUrl'
        )}/medias/sys_master/root/20210403/K3KJ/6068a0757cdb8c1f147924ed/eyebogler_green_polo_t-shirt_with_welt_pocket.jpg`,
        description: 'Armani Duffle Bag',
        label: 'Worth ₹15,000'
      },
      slot: {
        date: '2021-05-17',
        endTime: 1621281600,
        startTime: 1621274400,
        timeInterval: '15-18'
      },
      userList: [
        {
          mobile: '55XXXXXX67',
          name: 'Mukesh Khanna',
          rank: 0,
          uuid: '64dfbbf9-4374-4fe7-8cd1-4fda41d25764'
        },
        {
          mobile: '55XXXXXX67',
          name: 'Neha Dhall',
          rank: 0,
          uuid: '64dfbbf9-4374-4fe7-8cd1-4fda41d25764'
        },
        {
          mobile: '55XXXXXX67',
          name: 'Arpit Kumar',
          rank: 0,
          uuid: '64dfbbf9-4374-4fe7-8cd1-4fda41d25764'
        },
        {
          mobile: '55XXXXXX67',
          name: 'Sanjay Stalin',
          rank: 0,
          uuid: '64dfbbf9-4374-4fe7-8cd1-4fda41d25764'
        },
        {
          mobile: '55XXXXXX67',
          name: 'Abdul Samadh',
          rank: 0,
          uuid: '64dfbbf9-4374-4fe7-8cd1-4fda41d25764'
        }
      ]
    },
    {
      offer: {
        bannerImageURL: `${properties.getProperty(
          'imageBaseUrl'
        )}/medias/sys_master/root/20210403/K3KJ/6068a0757cdb8c1f147924ed/eyebogler_green_polo_t-shirt_with_welt_pocket.jpg`,
        description: 'Armani Duffle Bag',
        label: 'Worth ₹15,000'
      },
      slot: {
        date: '2021-05-18',
        endTime: 1621350000,
        startTime: 1621335600,
        timeInterval: '15-18'
      },
      userList: [
        {
          mobile: '55XXXXXX67',
          name: 'Mukesh Khanna',
          rank: 0,
          uuid: '64dfbbf9-4374-4fe7-8cd1-4fda41d25764'
        },
        {
          mobile: '55XXXXXX67',
          name: 'Neha Dhall',
          rank: 0,
          uuid: '64dfbbf9-4374-4fe7-8cd1-4fda41d25764'
        },
        {
          mobile: '55XXXXXX67',
          name: 'Arpit Kumar',
          rank: 0,
          uuid: '64dfbbf9-4374-4fe7-8cd1-4fda41d25764'
        },
        {
          mobile: '55XXXXXX67',
          name: 'Sanjay Stalin',
          rank: 0,
          uuid: '64dfbbf9-4374-4fe7-8cd1-4fda41d25764'
        },
        {
          mobile: '55XXXXXX67',
          name: 'Abdul Samadh',
          rank: 0,
          uuid: '64dfbbf9-4374-4fe7-8cd1-4fda41d25764'
        }
      ]
    },
    {
      offer: {
        bannerImageURL: `${properties.getProperty(
          'imageBaseUrl'
        )}/medias/sys_master/root/20210403/K3KJ/6068a0757cdb8c1f147924ed/eyebogler_green_polo_t-shirt_with_welt_pocket.jpg`,
        description: 'Armani Duffle Bag',
        label: 'Worth ₹15,000'
      },
      slot: {
        date: '2021-05-19',
        endTime: 1621422000,
        startTime: 1621418400,
        timeInterval: '15-18'
      },
      userList: [
        {
          mobile: '55XXXXXX67',
          name: 'Mukesh Khanna',
          rank: 0,
          uuid: '64dfbbf9-4374-4fe7-8cd1-4fda41d25764'
        },
        {
          mobile: '55XXXXXX67',
          name: 'Neha Dhall',
          rank: 0,
          uuid: '64dfbbf9-4374-4fe7-8cd1-4fda41d25764'
        },
        {
          mobile: '55XXXXXX67',
          name: 'Arpit Kumar',
          rank: 0,
          uuid: '64dfbbf9-4374-4fe7-8cd1-4fda41d25764'
        },
        {
          mobile: '55XXXXXX67',
          name: 'Sanjay Stalin',
          rank: 0,
          uuid: '64dfbbf9-4374-4fe7-8cd1-4fda41d25764'
        },
        {
          mobile: '55XXXXXX67',
          name: 'Abdul Samadh',
          rank: 0,
          uuid: '64dfbbf9-4374-4fe7-8cd1-4fda41d25764'
        }
      ]
    }
  ],
  saleType: 'PRE_SALE',
  upcomingSlots: [
    {
      offer: {
        bannerImageURL: `${properties.getProperty(
          'imageBaseUrl'
        )}/medias/sys_master/root/20210403/K3KJ/6068a0757cdb8c1f147924ed/eyebogler_green_polo_t-shirt_with_welt_pocket.jpg`,
        description: 'Armani Duffle Bag',
        label: 'Worth ₹15,000'
      },
      slot: {
        date: '2021-05-21',
        endTime: 0,
        startTime: 0,
        timeInterval: '15-18'
      },
      userList: [
        {
          mobile: '94XXXXXX89',
          name: 'Divya Bharti',
          rank: 0,
          uuid: '64dfbbf9-34374-4fe7-8cd1-4fda41d25762'
        }
      ]
    },
    {
      offer: {
        bannerImageURL: `${properties.getProperty(
          'imageBaseUrl'
        )}/medias/sys_master/root/20210403/K3KJ/6068a0757cdb8c1f147924ed/eyebogler_green_polo_t-shirt_with_welt_pocket.jpg`,
        description: 'Armani Duffle Bag',
        label: 'Worth ₹15,000'
      },
      slot: {
        date: '2021-05-17',
        endTime: 0,
        startTime: 0,
        timeInterval: '15-18'
      },
      userList: [
        {
          mobile: '94XXXXXX89',
          name: 'Divya Bharti',
          rank: 0,
          uuid: '64dfbbf9-34374-4fe7-8cd1-4fda41d25762'
        }
      ]
    }
  ]
};

export const data = [
  {
    imgSrc: `${properties.getProperty(
      'imageBaseUrl'
    )}/medias/sys_master/images/images/hd1/hc8/17458115018782/17072020-M-Unisex-OnlineStores-Trends.jpg`,
    rewardTitle: 'Armani Duffle Bag',
    rewardDesc: 'Worth ₹15,000',
    time: '9PM -12PM',
    timer: '2h 33m 12s'
  },
  {
    imgSrc: `${properties.getProperty(
      'imageBaseUrl'
    )}/medias/sys_master/images/images/hd1/hc8/17458115018782/17072020-M-Unisex-OnlineStores-Trends.jpg`,
    rewardTitle: 'Armani Duffle Bag',
    rewardDesc: 'Worth ₹15,000',
    time: '9PM -12PM',
    timer: '2h 33m 12s'
  },
  {
    imgSrc: `${properties.getProperty(
      'imageBaseUrl'
    )}/medias/sys_master/images/images/hd1/hc8/17458115018782/17072020-M-Unisex-OnlineStores-Trends.jpg`,
    rewardTitle: 'Armani Duffle Bag',
    rewardDesc: 'Worth ₹15,000',
    time: '9PM -12PM',
    timer: '2h 33m 12s'
  }
];

export const EVENT_HEADER_CONTENT = {
  header: 'Chance to win',
  subHeader: 'Rewards worth 70 Lakhs',
  image: BALOON_IMAGE
};

export const EVENT_HOW_TO_PARTICIPATE_CONTENT = {
  modalHeader: 'How to participate',
  list: [
    'Top Shopper contest is live for users during the Big Bold Sale',
    'All users placing orders during the contest duration will be considered for the participation',
    'Each day is divided into 8 slots of 3 hours each & for each slot, the top shopper(based on net order value) will be considered as the winner',
    'If user places multiple orders during same slot, those order values will be added & total order value is considered',
    'If two users placed order for same amount, the user who placed order earlier will be considered as the winner',
    'Please note that the net order value will be considered for each user after reducing the amount for any cancellations/returns',
    'Refer to the complete terms & conditions list for this contest using the link given below'
  ],
  linkText: 'Terms & conditions',
  href: TERMS_CONDITION_URL
};

export const EVENT_HOW_TO_PARTICIPATE_TC_CONTENT = {};

export const COMPONENT_STYLES = {
  eventCard: {
    desktop: {
      id: '',
      styles: {
        width: '84%',
        marginTop: '8%',
        marginBottom: '3.2rem'
      },
      classes: ''
    },
    mobile: {
      id: '',
      styles: {
        width: '90%',
        marginBottom: '2.4rem'
      },
      classes: ''
    }
  },
  howToParticipate: {
    desktop: {
      id: 'desk-HowtoParticipate',
      styles: {
        width: '84%',
        marginBottom: '3.2rem'
      },
      classes: ''
    },
    mobile: {
      id: 'mob-HowtoParticipate',
      styles: {
        width: '90%',
        marginBottom: '2.4rem'
      },
      classes: ''
    }
  },
  eventLeaderboard: {
    desktop: {
      id: '',
      styles: {
        width: '100%'
      },
      classes: ''
    },
    mobile: {
      id: '',
      styles: {
        width: '100%',
        marginBottom: '2.4rem'
      },
      classes: ''
    }
  },
  eventBanner: {
    desktop: {
      id: '',
      styles: {
        width: '100%',
        marginBottom: '3.2rem'
      },
      classes: ''
    },
    mobile: {
      id: '',
      styles: {
        width: '100%',
        marginBottom: '2rem'
      },
      classes: ''
    }
  },
  upcomingEvents: {
    desktop: {
      id: '',
      styles: {
        width: '100%'
      },
      classes: ''
    },
    mobile: {
      id: '',
      styles: {
        width: '100%',
        marginBottom: '2rem'
      },
      classes: ''
    }
  }
};
